import React from "react";

interface CategoryHeaderProps {
  categoryName: string;
  // When false, the label is rendered as-is without the trailing " vendors" suffix.
  showVendorsSuffix?: boolean;
}

export const CategoryHeader = ({ categoryName, showVendorsSuffix = true }: CategoryHeaderProps) => {
  return (
    <div
      className="category-header"
      style={{
        background: "#F9F8FB",
        borderBottom: "1px solid #D1CED9",
        fontFamily: "Roboto",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.6px", // 5% of 12px
        textTransform: "uppercase",
        color: "#534E65",
        padding: "12px 16px",
        marginBottom: "0px",
      }}
    >
      {showVendorsSuffix ? `${categoryName} vendors` : categoryName}
    </div>
  );
};
